import React from 'react';
import { IProps as IImageBlockProps } from './ImageBlock.interface';
import { ImageBlock } from './ImageBlock.component';
import TranslationComponent from '@/utils/TranslationComponent/TranslationComponent';
import * as translation from '@/utils/TranslationComponent/translation.utilities';

interface IImageBlockInputProps {
    image: {
        alternateText: string;
        defaultSrc: string;
        sizesAttribute: string[];
        srcSet: string[];
        srcSetWebp: string[];
        isBackground: boolean;
        textContent: string;
        isLazy: boolean;
    };
    ratio: string;
    caption: string;
    parentClass: string;
    [key: string]: any;
}

const mapInputToProps = (
    input: IImageBlockInputProps
): IImageBlockProps => {
    return {
        ...input,
        image: translation.mapImageProps(input.image),
        caption: input.caption,
        className: input.parentClass,
    } as IImageBlockProps;
};

const ImageBlockTranslation: React.FC<IImageBlockInputProps> = (
    inputProps
) => (
    <TranslationComponent
        inputProps={inputProps}
        TargetComponent={ImageBlock}
        mapProps={mapInputToProps}
    />
);

export default ImageBlockTranslation;